<template>
  <modal
    size="small"
    @close-modal="closeModal"
    @save-modal-changes="reportarPagina"
    class="Modal__reportar"
    :show-controls="false"
  >
    <div slot="header">Remover informações do Escavador</div>
    <div slot="content">
      <p>
        O Escavador apenas coleta e compila, automaticamente, dados que são
        públicos e disponíveis em fontes Oficiais, como o Diário Oficial, por
        exemplo. Toda informação acessível em nosso site é legal e pode ser
        acessada, da mesma maneira, nos sites de origem e em outros sites na
        Internet (Confira o nosso <a href="/termos-de-uso">Aviso Legal</a>).
      </p>
      <p>
        Para continuar com a remoção vamos solicitar um documento para garantir
        o controle e segurança dos seus próprios dados, por isso solicitamos que
        a remoção seja feita apenas pelo próprio titular. Os documentos
        solicitados são utilizados apenas e rigorosamente para a confirmação da
        identidade do solicitante.
      </p>
      <p>
        Caso esta página contenha informações invertidas de homônimos (pessoas
        com o mesmo nome), desatualizadas ou cujo conteúdo não deveria estar
        exposto (a exemplo de processos que correm em segredo de Justiça),
        continue com o processo de remoção.
      </p>
      <p>
        <b>Remoção em outros buscadores</b>
      </p>
      <p>
        Gostaríamos de esclarecer que o Google e outros sites de busca se atualizam 
        automaticamente e periodicamente para excluir páginas que não existem mais de 
        seus resultados de busca. Portanto, se o seu nome ainda aparecer nas pesquisas 
        após ter sido removido das páginas de diários e buscas do Escavador, 
        recomendamos solicitar a esses buscadores a desvinculação, visto que a página 
        não existe mais e o seu nome não está mais presente em nossa plataforma ou nas 
        páginas de diários.
      </p>
      <p>
        <b>Infelizmente, nós não temos qualquer controle sobre isso.</b>
      </p>
      <p>
        Para solicitar a remoção de conteúdo desatualizado no Google, acesse: 
        <a 
          href="https://search.google.com/search-console/remove-outdated-content" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          https://search.google.com/search-console/remove-outdated-content
        </a>
      </p>
      <p>
        <b
          >Nosso objetivo é tornar disponível, a todo e qualquer cidadão,
          informações que ele deveria ter direito ao acesso.</b
        >
      </p>
      <div class="c-controls">
        <button class="c-controls_cancel" @click="closeModal">Cancelar</button>
        <button class="c-controls_submit" @click="reportarPagina">
          Continuar remoção
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$emit("close");
    },
    reportarPagina() {
      this.$emit("reportar-pagina");
    },
  },
};
</script>

<style lang="stylus">
.Modal__reportar
    align-items flex-start !important
    & .Modal__header
      padding 0
      height auto
      min-height auto
      margin-bottom 16px !important
    & .Modal__dialog
      max-width 56rem !important
      padding 2rem !important
    & .Modal__footer
        margin-top 0
    & .Modal__content
        font-size 1rem !important
        padding 0 !important
        margin-top 0
    & .Modal__content a
        color #1d82e0
.c-controls
  display flex
  gap 0.5rem
  button
    font-size .875rem
    line-height 1.25rem
    font-weight 500
    padding-top .75rem
    padding-bottom .75rem
    padding-left 1rem
    padding-right 1rem
    border-radius 0.5rem
    border none
    height 2.5rem
    display flex
    align-items center
    justify-content center
  .c-controls_cancel
    background-color white
    border 1px solid rgb(209, 213, 219)
  .c-controls_cancel:hover
    background-color rgb(243, 244, 246)
  .c-controls_submit
    background-color rgb(254, 226, 226)
    color rgb(185, 28, 28)
  .c-controls_submit:hover
    background-color rgb(254, 202, 202)
</style>
